import styled from '@emotion/styled';
import React from 'react';

const Div = styled.div`
    white-space: nowrap;
`;

type ClickableProps = {
    children?: any;
    onClick: (params: any) => void;
} & React.HTMLAttributes<HTMLDivElement>;

const Clickable = ({ onClick, children, ...props }: ClickableProps) => {
    return (
        <Div onClick={onClick} {...props}>
            {children}
        </Div>
    );
};

export { Clickable };
